import {Record} from 'immutable';
import moment from 'moment-timezone';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface AbstractBudgetStateProps {
    fetching: boolean;
    loading: boolean;
    year: string;
    budget: {
        [date: string]: number;
    };
}
export class AbstractBudgetState extends Record<AbstractBudgetStateProps>({
    year: moment().format('YYYY'),
    budget: {},
    fetching: false,
    loading: false,
}) {}

export default makeReducer<AbstractBudgetState>(
    [
        match(
            Actions.fetchBudget,
            (state, {payload}) =>
                new AbstractBudgetState({
                    fetching: true,
                    year: payload.year,
                }),
        ),
        match(Actions.fetchBudgetSuccess, (state, {payload}) =>
            state.merge({
                fetching: false,
                budget: payload.response,
            }),
        ),
        match(Actions.fetchBudgetFailed, state =>
            state.merge({
                fetching: false,
            }),
        ),
        match(Actions.updateBudget, state =>
            state.merge({
                loading: true,
            }),
        ),
        match(Actions.updateBudgetSuccess, (state, {payload}) =>
            state.merge({
                loading: false,
                budget: payload.response,
            }),
        ),
        match(Actions.updateBudgetFailed, state =>
            state.merge({
                loading: false,
            }),
        ),
    ],
    new AbstractBudgetState(),
);
